import { StoreState } from '@statsig/statsig.entities';

export const userExperiments = (state: StoreState) => state.statsigExperiments;
